var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("商品抵扣列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入搜索：" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品名称" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_name", $$v)
                                    },
                                    expression: "form.goods_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "抵扣商品ID" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.wdid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wdid", $$v)
                                    },
                                    expression: "form.wdid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "市场" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.market_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "market_name", $$v)
                                    },
                                    expression: "form.market_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "选择城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.citys, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "品牌" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.brand_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "brand_name", $$v)
                                    },
                                    expression: "form.brand_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.woid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "woid", $$v)
                                    },
                                    expression: "form.woid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择买手组" },
                                        model: {
                                          value: _vm.form.pg_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pg_id", $$v)
                                          },
                                          expression: "form.pg_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionPicker,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择代采组" },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionPurchase,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择来源" },
                                        model: {
                                          value: _vm.form.referer,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "referer", $$v)
                                          },
                                          expression: "form.referer"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionReferer,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择状态" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionStatus,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "交易类型" },
                                        model: {
                                          value: _vm.form.pay_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pay_type", $$v)
                                          },
                                          expression: "form.pay_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionPayType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "订单负责人"
                                        },
                                        model: {
                                          value: _vm.form.order_owner,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "order_owner",
                                              $$v
                                            )
                                          },
                                          expression: "form.order_owner"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          key: 0,
                                          attrs: { value: "0", label: "全部" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.owner_option,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                value: item.value,
                                                label: item.label
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "次品组"
                                        },
                                        model: {
                                          value: _vm.form.dgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dgid", $$v)
                                          },
                                          expression: "form.dgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.dg_group, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "退换货负责人"
                                        },
                                        model: {
                                          value: _vm.form.dpc_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dpc_id", $$v)
                                          },
                                          expression: "form.dpc_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.option_dgm, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "售后退供员"
                                        },
                                        model: {
                                          value: _vm.form.refunder_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "refunder_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.refunder_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.dgm_refunder,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "生成渠道"
                                        },
                                        model: {
                                          value: _vm.form.ded_source,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "ded_source",
                                              $$v
                                            )
                                          },
                                          expression: "form.ded_source"
                                        }
                                      },
                                      _vm._l(
                                        _vm.constantMap.optionsSource,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "扫码出库人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_admin_str,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_admin_str",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.stock_out_create_admin_str"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采计划单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.planid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "planid", $$v)
                                    },
                                    expression: "form.planid"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "订单生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "default-time": ["00:00:00", "23:59:59"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.order_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "order_time", $$v)
                                    },
                                    expression: "form.order_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "待抵扣生成时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "default-time": ["00:00:00", "23:59:59"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "time", $$v)
                                    },
                                    expression: "form.time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "使用抵扣时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "default-time": ["00:00:00", "23:59:59"],
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.use_ded_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "use_ded_time", $$v)
                                    },
                                    expression: "form.use_ded_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退换货生成时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.stock_out_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v("\n      数据汇总    \n      "),
                  _c("span", [
                    _vm._v(
                      "待抵扣数量：" +
                        _vm._s(_vm.resData.total.wait_ded_num) +
                        "件        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "部分抵扣(坏账)数量：" +
                        _vm._s(_vm.resData.total.part_ded_num) +
                        "件        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "已抵扣数量：" +
                        _vm._s(_vm.resData.total.done_ded_num) +
                        "件        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "待抵扣金额：¥" +
                        _vm._s(_vm.resData.total.wait_ded_amount) +
                        "        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "已抵扣金额：¥" +
                        _vm._s(_vm.resData.total.part_ded_amount) +
                        "        "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("数据列表：")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "danger", size: "mini" },
                    on: { click: _vm.handleGoodsChangeOwn }
                  },
                  [_vm._v("转欠货")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", size: "mini" },
                    on: { click: _vm.output }
                  },
                  [_vm._v("导出")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        key: "table1",
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            selectable: _vm.isRowSelectable
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wdid",
                            label: "抵扣商品ID",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_img",
                            label: "商品图片"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.goods_img }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1325509903
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "商品货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "ded_doc",
                            label: "抵扣凭证"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.ded_doc
                                      ? _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "viewer",
                                                rawName: "v-viewer"
                                              }
                                            ],
                                            staticStyle: {
                                              width: "40px",
                                              height: "40px",
                                              overflow: "hidden",
                                              cursor: "pointer",
                                              margin: "auto"
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "100%"
                                              },
                                              attrs: { src: scope.row.ded_doc }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2675223900
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "market_name",
                            label: "市场",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_city",
                            label: "城市",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pg_name",
                            label: "买手组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "owner_admin_name",
                            label: "订单负责人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dg_group_name",
                            label: "次品组",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dgm_name",
                            label: "退换货负责人",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refunder",
                            label: "售后退供员",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "woid",
                            label: "代采单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_time",
                            label: "订单生成时间",
                            width: "120",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "work_id",
                            label: "工单id",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "代采价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pay_type",
                            label: "交易类型",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status",
                            label: "抵扣状态",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "balance",
                            label: "待抵扣金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_price",
                            label: "已抵扣金额",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "referer",
                            label: "来源",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_source_text",
                            label: "生成渠道",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "操作人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "待抵扣生成时间",
                            width: "120",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "use_ded_time",
                            label: "使用抵扣时间",
                            width: "120",
                            sortable: "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "ded_woid",
                            label: "使用的代采单号",
                            width: "120",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_admin_str",
                            label: "扫码出库人",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "90"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_time",
                            label: "退换货生成时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "150"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.count,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48805720", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48805720","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseDeduction.vue
// module id = null
// module chunks = 